import { useEffect, useState } from 'react';
import './index.scss';
import WalletCard from '../../../../../../components/WalletCard/WalletCard';

import SafelockActive from '../../../../../../assets/icons/SafelockActive.svg';

import chevronTable from '../../../../../../assets/icons/chevronTable.svg';
import NoData from '../../../../../../components/NoData/NoData';
import { useNavigate, useParams } from 'react-router-dom';

import SideSheet from '../../../../../../components/SideSheet/SideSheet';
import TransactionDetailsAlt from '../../../../../../components/NewSideSheet/TransactionDetailsAlt/TransactionDetailsAlt';
import useSafeLock from '../../../../../../hooks/useSafeLock';
import SafeLockSidesheet from '../../Sidesheets/SafeLock/SafeLockSidesheet';
import { Loader } from '@piggytechng/component-library';
import SafelockSearchModal, { EMPTY_SAFELOCK_SEARCH } from '../Safelock/viewall/SafelockSearchModal';
import { SafelockSearchParams } from '../../../../../../types';

const index = () => {
  const [showWalletBalance] = useState(true);
  const navigate = useNavigate();

  const {
    safelockBalancesQ,
    pendingSafelocksQ,
    completedSafelocksQ,
    safelockSearch,
    searchSafelocks,
    clearSafelockSearch,
  } = useSafeLock();
  const params = useParams();
  const [showSafeLockSideSheet, setShowSafeLockSideSheet] = useState(false);
  const [activeNairaTab, setActiveNairaTab] = useState(localStorage.getItem('activeNairaTab') || 'active');

  const [show, setShow] = useState(false);
  const [trDetails] = useState({});
  const [searchModal, setSearchModal] = useState(false);
  const [searchParams, setSearchParams] = useState<SafelockSearchParams>({ ...EMPTY_SAFELOCK_SEARCH });

  const walletKey = 'safelock';

  useEffect(() => {
    localStorage.setItem('activeNairaTab', activeNairaTab);
  }, [activeNairaTab]);

  const walletCardsData: any = [
    {
      title: 'Safelock Naira Balance:',
      balanceKey: safelockBalancesQ?.nairaBalance ?? 0,
      cardId: 'hm-card',
      image: SafelockActive,
      isActive: true,
      isOpenSideSheet: true,
      cardClick: () => setShowSafeLockSideSheet(false),
    },
    {
      title: 'Safelock Dollar Balance:',
      balanceKey: safelockBalancesQ?.dollarBalance ?? 0,
      cardId: 'hm-card',
      image: SafelockActive,
      isActive: true,
      isOpenSideSheet: true,
      cardClick: () => setShowSafeLockSideSheet(false),
    },
  ];

  const id = params.id as string;

  const status = activeNairaTab === 'active' ? 0 : 1;

  const tabList: any[] = (activeNairaTab === 'active' ? pendingSafelocksQ?.list : completedSafelocksQ?.list) ?? [];

  const list = safelockSearch.isActive ? safelockSearch.list : tabList.slice(0, 5);

  const applySearch = (filters: SafelockSearchParams) => {
    setSearchParams(filters);
    searchSafelocks(id, status, filters);
  };

  const resetSearch = () => {
    setSearchParams({ ...EMPTY_SAFELOCK_SEARCH });
    clearSafelockSearch();
  };

  const switchTab = (tab: string) => {
    setActiveNairaTab(tab);
    // The status is part of the search path, so a stale result set would be wrong here.
    if (safelockSearch.isActive) resetSearch();
  };

  return (
    <>
      <div className="wallet-safelock-page">
        <div className="cards-container flex--2">
          {walletCardsData.map((item: any, i: any) => (
            <WalletCard
              key={i}
              {...item}
              showBalance={showWalletBalance}
              balance={item.balanceKey}
              walletKey={walletKey}
            />
          ))}
        </div>
        {/* <div className="tab-switch flex--2">
          <p className={`pointer tab ${activeTab === 'active' && 'active'}`} onClick={() => setActiveTab('active')}>
            Naira Safelock
          </p>
          <p
            className={`pointer tab ${activeTab === 'completed' && 'active'}`}
            // onClick={() => setActiveTab('completed')}
          >
            Dollar Safelock
          </p>
        </div> */}

        <div className="tab-switch flex--2">
          <p className={`pointer tab ${activeNairaTab === 'active' && 'active'}`} onClick={() => switchTab('active')}>
            Ongoing Safelocks
          </p>
          <p
            className={`pointer tab ${activeNairaTab === 'completed' && 'active'}`}
            onClick={() => switchTab('completed')}
          >
            Completed Safelocks
          </p>
        </div>
        <div className="wallets-details">
          <div className="flex--3">
            <h1 className="heading">Safelocks History</h1>
            <p className="view-all-g" onClick={() => navigate(`/view-all-safelocks/${id}/${activeNairaTab}`)}>
              View all
            </p>
          </div>
          <div className="customers-filter">
            <div className="input-field pointer" onClick={() => setSearchModal(true)}>
              <input type="text" placeholder="Search by Safelock ID, title, amount or date" readOnly />
            </div>
            <div className="query-filter pointer" onClick={() => setSearchModal(true)}>
              <div>
                <svg width="10" height="10" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M0.75 0.75H17.25M6.75 13.25H11.25M3.75 7H14.25"
                    stroke="#1E293B"
                    strokeWidth="1.5"
                    strokeLinecap="square"
                  />
                </svg>
              </div>
              <div>Search</div>
            </div>
            {safelockSearch.isActive && (
              <div className="query-filter pointer" onClick={resetSearch}>
                <div></div>
                <div>Reset</div>
              </div>
            )}
          </div>

          {safelockSearch.isActive && !safelockSearch.isLoading && (
            <p className="search-summary">
              {safelockSearch.total
                ? `Showing ${safelockSearch.list.length} of ${safelockSearch.total} result${
                    safelockSearch.total === 1 ? '' : 's'
                  }`
                : 'No safelocks match your search'}
            </p>
          )}
        </div>
        <div className="safelocks-table flex--4">
          {safelockSearch.isLoading ? (
            <div className="page-loader">
              <Loader color="#0F60D6" />
            </div>
          ) : list.length ? (
            list.map((item: any, key: any) => (
              <div
                className="row-t pointer flex--2"
                key={key}
                onClick={() => {
                  navigate(`/view-safelock/${id}/${item.safelockId}`);
                }}
              >
                <div className="flex--2">
                  <div className="img-cont">
                    <img src={item.image} alt="" />
                  </div>

                  <div className="sect-1 flex--4">
                    <h3>
                      {item.title}
                      {item?.isRollover && <span className="rollover-badge">Rolled Over</span>}
                    </h3>
                    <p>{item?.keyPoints[0]?.value}</p>
                    <small>{item?.keyPoints[0]?.label}</small>
                  </div>
                </div>

                <div className="sect-2 end flex--4">
                  <small>{item.progressText}</small>
                </div>
                <img className="chevron-table" src={chevronTable} />
              </div>
            ))
          ) : (
            <NoData
              message={
                safelockSearch.isActive
                  ? 'No safelocks match your search.'
                  : `No ${activeNairaTab === 'active' ? 'Ongoing' : 'Completed'} Safelock at the moment.`
              }
              actionText={safelockSearch.isActive ? 'Clear search' : undefined}
              action={safelockSearch.isActive ? resetSearch : undefined}
            />
          )}
        </div>
      </div>

      <SafelockSearchModal
        modalIsOpen={searchModal}
        setIsOpen={setSearchModal}
        data={searchParams}
        searchDataBy={applySearch}
        onClear={resetSearch}
      />

      {showSafeLockSideSheet && (
        <SideSheet active={showSafeLockSideSheet} onClose={() => setShowSafeLockSideSheet(false)} hideCloseButton>
          <SafeLockSidesheet userId={id} onClose={() => setShowSafeLockSideSheet(false)}></SafeLockSidesheet>
        </SideSheet>
      )}

      <TransactionDetailsAlt
        show={show}
        id={''}
        data={trDetails}
        onClose={() => {
          setShow(false);
        }}
      />
    </>
  );
};

export default index;
